module.exports = __webpack_public_path__ + "static/YibiaoWang-aeb0cbe20e04a5f0fc8c0220a3fd2016.jpeg";